<template>
    <div id="not-found">
        页面不存在！
    </div>
</template>

<script>
    export default {
        name: 'Notfound'
    }
</script>

<style scoped>
    #not-found {
        width: 100%;
        height: 100%;
        position: absolute;
        z-index:999;
        background-color: #fff;
        top:0;
        left:0;
    }
</style>


// WEBPACK FOOTER //
// src/components/404.vue